import { User } from "components/User";
import { toast } from "react-toastify";
import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FullScreenLoader, PageTitle } from "components";
import { useGetUserQuery, useUpdateUserMutation } from "redux/api/userApi";
import { useGetAllCompaniesQuery } from "redux/api/companyApi";
import { ISelectOption } from "Interfaces/Utils";
import { ICompany } from "Models/Company";
import { useIntl } from "react-intl";

// Static vars
const RETURN_PAGE = "/users";


/**
 * Component to render user edition view
*/

const UserEditPage = () => {
    const { formatMessage } = useIntl();
  
  const PAGE_TITLE = formatMessage({ id: "user.editTitle" });
  const RETURN_LABEL = formatMessage({ id: "user.back" });
  const UPDATE_SUCCESS_LABEL = formatMessage({ id: "user.updatedSuccessfuly" });
  const { userId } = useParams();

  const navigate = useNavigate();

  // API calls

  const { data: user, isLoading: isUserLoading } = useGetUserQuery(String(userId));
  const [updateUser, { isSuccess: isUpdatedUserSuccess, error: apiError }] = useUpdateUserMutation();
  const { data: companies, isLoading: isCompanyLoading } = useGetAllCompaniesQuery();

  // UseEffect to manage creation success

  useEffect(() => {
    if (isUpdatedUserSuccess) {
      toast.success(UPDATE_SUCCESS_LABEL);
      navigate(RETURN_PAGE);
    }
  }, [isUpdatedUserSuccess, navigate]);

  // Function to manage form submit

  const updateUserHandler = (formData: FormData) => {
    updateUser({ userId: String(userId), updatedUser: formData });
  };
  const groupSelectOptions: ISelectOption[] = useMemo(() => {

    if (!companies||!companies) return [];

    return companies.map((company: ICompany) => ({
      label: company.name,
      value: company._id,
    }));
    
  }, [companies])
  if (isUserLoading||isCompanyLoading) return <FullScreenLoader />;

  return (
    <>
      <PageTitle
        pageTitle={PAGE_TITLE}
        returnPage={RETURN_PAGE}
        returnLabel={RETURN_LABEL}
      />
      <User.Form
        companies={groupSelectOptions}
        currentUser={user}
        createApiError={apiError}
        onSubmit={updateUserHandler}
      />
    </>
  );
};

export default UserEditPage;